import { Component, OnInit } from '@angular/core';
import { GlobalConstantsKtblAdressen } from 'globales-projekt-angular';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit {
  ktbl: string = GlobalConstantsKtblAdressen.KTBL;
  kontakt: string = GlobalConstantsKtblAdressen.KONTAKT;
  impressum: string = GlobalConstantsKtblAdressen.IMPRESSUM;
  nutzungsbedingungen: string = GlobalConstantsKtblAdressen.NUTZUNGSBEDINGUNGEN;
  datenschutzerklaerung: string =
    GlobalConstantsKtblAdressen.DATENSCHUTZERKLAERUNG;

  constructor() {}

  ngOnInit(): void {}
}
